import { Favorite as FavoriteIcon } from "@/components/Icon/Favorite"
import { useWishlist } from "@/lib/store/wishlist"
import { gtmAddToWishlist, gtmRemoveFromWishlist } from "@jog/shared"
import classNames from "classnames"
import { MouseEventHandler, useCallback, useMemo } from "react"

export const Favorite = ({
    productId,
    gtmId,
    name,
    price,
    className = "bottom-4 right-4",
}: {
    productId: string
    gtmId: string
    name: string
    price: number
    className?: string
}) => {
    const addWishlistItem = useWishlist.use.addWishlistItem()
    const removeProductFromWishlist = useWishlist.use.removeWishlistItem()
    const favoriteProducts = useWishlist.use.simpleWishlist()?.lineItems
    const lineItemId = useMemo(
        () => favoriteProducts?.find((lineItem) => lineItem.productId === productId)?.id,
        [favoriteProducts, productId]
    )
    const onClick = useCallback<MouseEventHandler>(
        async (e) => {
            e.preventDefault()
            if (!lineItemId) {
                gtmAddToWishlist([{ id: gtmId, name, price }])
                await addWishlistItem(productId)
            } else {
                gtmRemoveFromWishlist([{ id: gtmId, name, price }])
                await removeProductFromWishlist(lineItemId)
            }
        },
        [addWishlistItem, gtmId, lineItemId, name, price, productId, removeProductFromWishlist]
    )
    return (
        <div
            className={classNames("absolute flex cursor-pointer items-center justify-center", className)}
            onClick={onClick}>
            <FavoriteIcon
                className={classNames(
                    lineItemId ? "fill-orange-tangerine text-orange-tangerine" : "fill-white text-black"
                )}
            />
        </div>
    )
}
